import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "./data";
import { Eyebrow, Reveal } from "./Reveal";

const MotionLink = motion.create(Link);

const Card = ({ s, i }) => (
  <MotionLink
    to={`/services/${s.to}`}
    data-testid={`service-card-${s.key}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    className={`group relative min-h-[260px] overflow-hidden rounded-3xl text-left sm:min-h-[300px] ${i === 0 ? "bg-[#FFB000] text-[#0D0D0B]" : "bg-[#0D0D0B] text-[#F2EEE6]"} ${s.span}`}
  >
    <s.icon className={`pointer-events-none absolute -bottom-6 -right-6 transition-transform duration-[1200ms] ease-out group-hover:-rotate-6 group-hover:scale-110 ${i === 0 ? "h-80 w-80 text-[#0D0D0B]/10 lg:h-[26rem] lg:w-[26rem]" : "h-48 w-48 text-[#FFB000]/15"}`} strokeWidth={1.25} />
    <div className="relative flex h-full flex-col justify-between p-6 sm:p-8">
      <div className="flex items-start justify-between">
        <span className={`grid h-14 w-14 place-items-center rounded-2xl ${i === 0 ? "bg-[#0D0D0B] text-[#FFB000]" : "bg-[#FFB000] text-[#0D0D0B]"}`}><s.icon className="h-7 w-7" strokeWidth={2.25} /></span>
        <span className={`grid h-11 w-11 place-items-center rounded-full transition-[transform,background-color] duration-500 group-hover:rotate-45 ${i === 0 ? "bg-[#0D0D0B] text-[#FFB000]" : "bg-[#F2EEE6] text-[#0D0D0B] group-hover:bg-[#FFB000]"}`}>
          <ArrowUpRight className="h-5 w-5" strokeWidth={2.5} />
        </span>
      </div>
      <div>
        <span className={`font-display text-2xl ${i === 0 ? "text-[#0D0D0B]" : "text-[#FFB000]"}`}>{s.n}</span>
        <h3 className={`font-display uppercase leading-none ${i === 0 ? "text-7xl sm:text-9xl" : "text-5xl sm:text-6xl"}`}>{s.title}</h3>
        <div className="mt-4 flex flex-wrap gap-2">
          {s.items.map((it) => (
            <span key={it} className={`rounded-full border px-3 py-1 text-xs font-semibold ${i === 0 ? "border-[#0D0D0B]/30" : "border-white/25"}`}>{it}</span>
          ))}
        </div>
      </div>
    </div>
  </MotionLink>
);

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-[#F2EEE6] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="mb-12 grid gap-6 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-8">
          <Eyebrow dark>Junk removal services in Greenville SC</Eyebrow>
          <h2 className="font-display mt-4 text-6xl uppercase leading-[0.9] text-[#0D0D0B] sm:text-8xl">If it's junk,<br />it's gone.</h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4">
          <p className="text-base text-[#3a3a35] sm:text-lg">Furniture, appliances, hot tubs, yard waste and full cleanouts for homes and businesses. Point at it, we lift it and load it. Tap a service to learn more.</p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:auto-rows-[320px] lg:grid-cols-12 lg:gap-5">
        {SERVICES.map((s, i) => <Card key={s.key} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
